import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { ReactComponent as CloseIconRed } from "../../assests/icons/close_icon_red.svg";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import { dialogActions } from "../../store/reducers/dialog";
import CircularLoader from "../CircularLoader";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RequestsToken } from "../../utils/constant";
import { RequestDialogWrap } from "./Dialog.styles";

const RequestsAcceptDialog = ({
  dialogTitle,
  dialogContentBtn,
  dialogContentRight,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(true);
  const [loader, setLoader] = React.useState(false);
  const theme = useTheme();
  const dialogData = useSelector((state) => state.dialog.dataObj);
  const firstName = (Object.keys(dialogData).length>=1)?dialogData.name.split(" ")[0]:"";
  const dialogContentLeft=t(RequestsToken.AcceptRequestDialogSuccessLeft, { 0 : firstName });

  const handleClose = () => {
    setOpen(false);
    dispatch(dialogActions.setIsDialogEnabled(false));
    dispatch(dialogActions.setDialogType(""));
    dispatch(dialogActions.setDataObj({}));
    dispatch(dialogActions.setRequestId(0));
  };

 
 
  const handleConnectConnectionRedirect = () => {
    setOpen(false);
    dispatch(dialogActions.setIsDialogEnabled(false));
    dispatch(dialogActions.setDialogType(""));
    dispatch(dialogActions.setDataObj({}));
    dispatch(dialogActions.setRequestId(0));
    window.location.href = `/web/secure/composeMessage?userId=${dialogData.connectionUser}&userName=${encodeURI(dialogData.name)}&canRecipientListVisible=false`;
    return;
  
  }
  





  

  return (
    <Box  >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth={false}
      >
        <RequestDialogWrap>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              paddingBottom: "0.2rem",
              borderBottom: "1px solid #c8c8c8",
            }}
          >
            <DialogTitle
              id="responsive-dialog-title"
              sx={{
                margin: "auto",
                padding: "0",
                fontSize: "2.5rem",
                color: "#cf2030",
              }}
            >
              {dialogTitle}
            </DialogTitle>
            <CloseIconRed onClick={handleClose} />
          </Box>
          <DialogContent>
          <DialogContentText sx={{ textAlign: "center", "@media only screen and (max-width: 750px)": {
                fontSize: "16px",
              } }}>
            <Typography>{dialogContentLeft}<Box
                  component={"span"}
               onClick={handleConnectConnectionRedirect}
                  sx={{
                    fontSize: "1.6rem",
                    fontWeight: "600",
                    color:"#cf2030",
                    boxShadow: "0px 3px 0px -1px #cf2030",
                    cursor: "pointer",
                    marginRight:"0.5rem",
                    marginLeft:"0.5rem"
                  }}
                >
                  {dialogContentBtn}
                </Box>
                {dialogContentRight}
                </Typography>
            
          </DialogContentText>
        </DialogContent>
      
        </RequestDialogWrap>
      </Dialog>
      {loader && <CircularLoader />}
    </Box>
  );
};

export default RequestsAcceptDialog;
